let timeout: ReturnType<typeof setTimeout>;

// https://stackoverflow.com/questions/3515446/jquery-mousewheel-detecting-when-the-wheel-stops
export function onMouseWheelEnd(callback: () => void): void {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback(), 100);
}
